export default __webpack_public_path__ + "static/media/Colier-banner.f91b201c.png";